import { cn } from "@/lib/utils"

import { searchDiscAppearance } from "./appearance"
import {
  CasinoGlyph,
  MenuGlyph,
  PromotionsGlyph,
  SearchGlyph,
  SportsGlyph,
  TournamentsGlyph,
  UserGlyph,
  VipGlyph
} from "./glyphs"
import { NavIconPaint } from "./paint"
import type { NavIconProps } from "./types"

const glyphs = {
  menu: MenuGlyph,
  casino: CasinoGlyph,
  search: SearchGlyph,
  sports: SportsGlyph,
  user: UserGlyph,
  tournaments: TournamentsGlyph,
  promotions: PromotionsGlyph,
  vip: VipGlyph
} as const

export function NavIcon({
  name,
  variant = "inactive",
  className
}: NavIconProps) {
  if (name === "search") {
    return (
      <span
        className={cn(
          "inline-flex size-12 shrink-0 items-center justify-center overflow-visible rounded-full",
          searchDiscAppearance[variant],
          className
        )}
      >
        <SearchGlyph className="size-6" />
      </span>
    )
  }

  const Glyph = glyphs[name]

  return (
    <NavIconPaint variant={variant} className={className}>
      <Glyph className="max-h-full max-w-full overflow-visible" />
    </NavIconPaint>
  )
}
